/**
 * Deletes the speaker-separation results on their own, leaving the transcript.
 *
 * Mirrors transcription-delete.saga: fire the delete, wait for it, then apply
 * the same drop to the main and worker stores so the view falls back to the
 * flat transcript without a reload. Deleting is also the only route to a second
 * run — the Run option hides while a separated transcript exists, which is why
 * a delete that reports success without deleting anything strands the user.
 */
import { enqueueSnackbar } from '@common-modules/snackbar';
import {
  actionApplyDeleteSpeakerSeparation,
  DELETE_SPEAKER_SEPARATION_RESULTS,
  DELETE_SPEAKER_SEPARATION_RESULTS_FAILURE,
  DELETE_SPEAKER_SEPARATION_RESULTS_SUCCESS,
} from '../actions/transcription';
import { deleteSpeakerSeparationResults } from '../services';
import { sagaIntl } from '@i18n';
import { IN_APPLY_DELETE_SPEAKER_SEPARATION } from '@common/web-worker';
import { race, take, takeLatest, put } from 'typed-redux-saga/macro';

export function* watchDeleteSpeakerSeparationResults() {
  yield* takeLatest(
    DELETE_SPEAKER_SEPARATION_RESULTS,
    handleDeleteSpeakerSeparationResults
  );
}

function* handleDeleteSpeakerSeparationResults() {
  yield* put(deleteSpeakerSeparationResults());

  const { success } = yield* race({
    success: take(DELETE_SPEAKER_SEPARATION_RESULTS_SUCCESS),
    failure: take(DELETE_SPEAKER_SEPARATION_RESULTS_FAILURE),
  });

  const intl = sagaIntl();

  if (success) {
    const metadata = {
      description: intl.formatMessage({
        id: 'deleteSpeakerSeparationHistory',
        defaultMessage: 'delete speaker separation',
      }),
    };

    yield* put(actionApplyDeleteSpeakerSeparation());
    yield* put(IN_APPLY_DELETE_SPEAKER_SEPARATION({ metadata }));
    yield* put(
      enqueueSnackbar({
        message: intl.formatMessage({
          id: 'deleteSpeakerSeparationSuccess',
          defaultMessage: 'Speaker separation deleted',
        }),
      })
    );
    return;
  }

  yield* put(
    enqueueSnackbar({
      message: intl.formatMessage({
        id: 'deleteSpeakerSeparationFailure',
        defaultMessage: 'Failed to delete speaker separation',
      }),
    })
  );
}
